import React from 'react';
import PropTypes from 'prop-types';

class CaveErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[CaveErrorBoundary] Render error caught:', error, info);

    // Report via the Datadog RUM global rather than a module import: per
    // platform/monitoring/Datadog the `@datadog/browser-rum` module import
    // breaks the webpack test/E2E bundle. `window.DD_RUM` is set once the app
    // is onboarded to Datadog; until then this is a safe no-op.
    window.DD_RUM?.addError(error, {
      component: 'CaveErrorBoundary',
      errorType: 'cave-error-boundary-render-failure',
      componentStack: info?.componentStack,
    });
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <va-alert status="error" uswds>
          <h2 slot="headline">Something went wrong</h2>
          <p>
            We're sorry. We weren't able to display this section. Go back and
            try again.
          </p>
          <p>
            <va-button
              text="Go back"
              onClick={() => window.history.back()}
              uswds
              data-dd-action-name="Cave Error Go Back"
            />
          </p>
        </va-alert>
      );
    }

    return children;
  }
}

CaveErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CaveErrorBoundary;
